import Button from '@mui/material/Button';
import React from 'react';

interface ILinkButton {
  onClick: () => void;
  text: string;
  [k: string]: any;
}

const LinkButton: React.FC<ILinkButton> = ({ onClick, text, ...rest }) => (
  <Button variant="footer" onClick={onClick} {...rest}>
    {text}
  </Button>
);

export default LinkButton;
